import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEventAgentSearchInterface } from '../data/event-agent-search.interface';
import { GtmStatsAdapterSearchAction } from './search-action';

export class GtmStatsAdapterEventAgentSearch implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventAgentSearchInterface {
    const event: GtmStatsDataEventAgentSearchInterface = {
      event: 'Agents Section',
      eventAction: 'Search:Agent',
      eventLabel: {
        Action: 'Initial',
        Location: ' ',
        Broker: ' ',
        Text: ' ',
        Page: 0,
        Sort: ' ',
        NumberOfResults: 0,
        Agent: ' ',
        ServiceNeeded: ' ',
        Language: ' ',
        Nationality: ' ',
      },
    };

    // Action
    event.eventLabel.Action = new GtmStatsAdapterSearchAction(this.context.global.agent_search.trigger).getData();

    // Location
    if (this.context.global.agent_search.location_id) {
      event.eventLabel.Location = String(this.context.global.agent_search.location_id);
    }

    // Broker
    if (this.context.global.agent_search.broker_id) {
      event.eventLabel.Broker = String(this.context.global.agent_search.broker_id);
    }

    // Text
    if (this.context.global.agent_search.text) {
      event.eventLabel.Text = String(this.context.global.agent_search.text);
    }

    // Page
    if (this.context.local.pagination && this.context.local.pagination.pageCurrent) {
      event.eventLabel.Page = this.context.local.pagination.pageCurrent;
    }

    // Sort (yes, we are passing sort_text not sort_id)
    if (this.context.global.agent_search.sort_text) {
      event.eventLabel.Sort = this.context.global.agent_search.sort_text;
    }

    // Number of results
    if (this.context.local.pagination && this.context.local.pagination.itemTotal) {
      event.eventLabel.NumberOfResults = this.context.local.pagination.itemTotal;
    }

    // Agent
    if (this.context.global.agent_search.agent_id) {
      event.eventLabel.Agent = String(this.context.global.agent_search.agent_id);
    }

    // Service needed (yes, we are passing category_text not category_id)
    if (this.context.global.agent_search.category_text) {
      event.eventLabel.ServiceNeeded = this.context.global.agent_search.category_text;
    }

    // Language (yes, we are passing language_texts not language_ids)
    if (this.context.global.agent_search.language_texts && this.context.global.agent_search.language_texts.length) {
      event.eventLabel.Language = this.context.global.agent_search.language_texts.join(', ');
    }

    // Nationality (yes, we are passing nationality_text not nationality_id)
    if (this.context.global.agent_search.nationality_text) {
      event.eventLabel.Nationality = this.context.global.agent_search.nationality_text;
    }

    return event;
  }
}
